import { isExperimentActive } from '@pegasus/abtesting';
import { Experiment } from '@pegasus/abtesting/types/experiments';

/* eslint-disable camelcase */
/* eslint-disable import/export */
type Events = {
    settings_order_cancel: {
        orderID: string;
    };
    settings_order_return: {
        orderID: string;
    };
    settings_order_tracking: {
        orderID: string;
    };
    settings_order_loadMore: never;
    settings_order_orderDetail: {
        orderID: string;
    };
    settings_order_orderFilter: {
        filter: string | number;
    };
    settings_order_cancelConfirm: {
        component: string;
        items?: string;
        addInfo?: string;
        productSku: string;
        orderID: string;
    };
    settings_order_shopNow: never;
    settings_return_returnHelp: never;
    settings_return_labelDownload: never;
    settings_return_labelEmail: never;
    removeFromCart: object;
    TRACK_DATA: object;
    TRACK_ABTESTING: object;
};

type NeverProperties<T> = ({ [P in keyof T]: T[P] extends never ? P : never })[keyof T];
type WithPayloadEvent = keyof Omit<Events, NeverProperties<Events>>;
type WithoutPayloadEvent = keyof Pick<Events, NeverProperties<Events>>;

export function track(event: WithoutPayloadEvent): number | false;
export function track<T extends WithPayloadEvent>(event: T, payload: Events[T]): number | false;
export function track(event: any, payload?: any): number | false {
    const trackingInfo: any = { event };

    if (typeof payload === 'object') {
        Object.assign(trackingInfo, payload);
    }
    if (typeof payload === 'string') {
        Object.assign(trackingInfo, { data: payload });
    }

    return typeof window !== 'undefined' && window.dataLayer && window.dataLayer.push(trackingInfo);
}

export const trackABTest = (experiment: Experiment) => {
    if (!isExperimentActive(experiment)) {
        return;
    }

    const { variant, feedbackId, mode, id, assignmentKey } = experiment;
    const ASSIGNMENT_KEY_TO_TRACKUSER = {
        customerHash: 'visitorID',
        clientid: 'clientID',
    };

    track('TRACK_ABTESTING', {
        octopus_testName: id,
        octopus_variantName: variant,
        octopus_feedbackID: feedbackId,
        octopus_mode: mode,
        ...(assignmentKey && {
            [ASSIGNMENT_KEY_TO_TRACKUSER[assignmentKey.key]]: assignmentKey.value,
        }),
    });
};
